import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Phone, Mail, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden bg-offwhite" data-id="element-155">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy/5 -skew-x-12 translate-x-1/4 z-0" data-id="element-156" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl z-0" data-id="element-157" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10" data-id="element-158">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-160">
            <div className="inline-block px-3 py-1 bg-gold/20 text-navy-dark rounded-full text-sm font-semibold mb-6" data-id="element-161">
              Fast. Reliable. Convenient.
            </div>
            <h1 className="text-4xl md:text-6xl font-heading font-bold text-navy leading-tight mb-6" data-id="element-162">
              A Dream Smile is a <span className="text-gold" data-id="element-163">Reality</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed max-w-lg" data-id="element-164">
              We provide easy access to loans for Individuals, SMMEs, and
              Private Sector businesses with a 24-hour turnaround time and
              competitive rates.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-165">
              <Button size="lg" onClick={() => window.location.href = '#apply'} data-id="element-166">
                Apply Now <ArrowRight className="ml-2 h-5 w-5" data-id="element-167" />
              </Button>
              <Button variant="outline" size="lg" onClick={() => window.location.href = '#contact'} data-id="element-168">
                Speak to an Advisor
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 text-sm text-gray-600 border-t border-gray-200 pt-6" data-id="element-169">
              <a href="tel:+26774833041" className="flex items-center hover:text-navy transition-colors" data-id="element-170">
                <Phone className="h-4 w-4 mr-2 text-gold" data-id="element-171" />
                +267 74 833 041
              </a>
              <a href="tel:+26777685555" className="flex items-center hover:text-navy transition-colors" data-id="element-172">
                <Phone className="h-4 w-4 mr-2 text-gold" data-id="element-173" />
                +267 77 685 555
              </a>
              <a href="mailto:derien@derien.co.bw" className="flex items-center hover:text-navy transition-colors" data-id="element-174">
                <Mail className="h-4 w-4 mr-2 text-gold" data-id="element-175" />
                derien@derien.co.bw
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative hidden md:block" data-id="element-176">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-177">
              <img src="https://cdn.magicpatterns.com/uploads/sVNHbCtnQnyzzvfJ6rKTBP/home_img.png" alt="De Rien Cash Loan office reception" className="w-full h-auto object-cover" data-id="element-178" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy/90 to-transparent p-8 text-white" data-id="element-179">
                <p className="font-bold text-lg" data-id="element-180">24-Hour Turnaround</p>
                <p className="text-sm opacity-90" data-id="element-181">
                  Quick approval process for your peace of mind.
                </p>
              </div>
            </div>
            {/* Decorative backing */}
            <div className="absolute -top-4 -right-4 w-full h-full bg-gold rounded-2xl -z-10" data-id="element-182" />
          </motion.div>
        </div>
      </div>
    </section>;
}